import LogedSection from './GrouTwoComponents/LogedSection'
import UnlogedSection from './GrouTwoComponents/UnlogedSection'
import styles from './styles/GroupTwo.module.css'

export default function GroupTwo({ userIsLoged, usersex }) {
  return (
    <div className={styles.group_two}>
      {
        userIsLoged ? (
          <LogedSection usersex={usersex}/>
        ) : (
          <UnlogedSection />
        )
      }
    </div>
  )
}